import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Country, Transactions } from './types';

export type StatusPayload = {
  conditions: object;
  limit: number | null;
  offset: number;
  isDownloadList?: boolean;
};

export const initialState: {
  isLoading: boolean;
  isSuccess: boolean;
  error: string | Error | null;
  data: Transactions[];
  totalCount: number;
  transactionAllList: {
    isLoading: boolean;
    isSuccess: boolean;
    error: string | Error | null;
  };
  countries: {
    isLoading: boolean;
    isSuccess: boolean;
    error: string | Error | null;
    data: Country[];
  };
} = {
  isLoading: false,
  isSuccess: false,
  error: null,
  data: [],
  totalCount: -1,
  transactionAllList: {
    isLoading: false,
    isSuccess: false,
    error: null,
  },
  countries: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: [],
  },
};

export const transactionsList = createSlice({
  name: 'transactionsList',
  initialState: initialState,
  reducers: {
    getTransactionsAction: (state, { payload }: PayloadAction<StatusPayload>) => {
      const { isDownloadList } = payload;
      if (isDownloadList) {
        state.transactionAllList.isLoading = true;
        state.transactionAllList.isSuccess = false;
        state.transactionAllList.error = null;
      } else {
        state.isLoading = true;
        state.isSuccess = false;
        state.error = null;
      }
    },

    getTransactionsSuccessAction: (
      state,
      { payload }: PayloadAction<{ data: Transactions[]; isDownloadList?: boolean; count: number }>,
    ) => {
      if (payload?.isDownloadList) {
        state.transactionAllList.isSuccess = true;
        state.transactionAllList.isLoading = false;
        state.transactionAllList.error = null;
      } else {
        state.data = payload.data;
        state.totalCount = payload.count;
        state.isSuccess = true;
        state.isLoading = false;
        state.error = null;
      }
    },

    getTransactionsErrorAction: (
      state,
      { payload }: PayloadAction<{ error: string | Error; isDownloadList?: boolean }>,
    ) => {
      if (payload?.isDownloadList) {
        state.transactionAllList.error = payload.error;
        state.transactionAllList.isLoading = false;
        state.transactionAllList.isSuccess = false;
      } else {
        state.error = payload.error;
        state.isLoading = false;
        state.isSuccess = false;
      }
    },

    getCountriesAction: (state) => {
      state.countries.isLoading = true;
      state.countries.isSuccess = false;
      state.countries.error = null;
    },

    getCountriesSuccessAction: (state, { payload }: PayloadAction<{ data: Country[] }>) => {
      state.countries.data = payload.data;
      state.countries.isSuccess = true;
      state.countries.isLoading = false;
      state.countries.error = null;
    },

    getCountriesErrorAction: (state, { payload: error }) => {
      state.countries.error = error;
      state.countries.isLoading = false;
      state.countries.isSuccess = false;
    },
  },
});

export const {
  getTransactionsAction,
  getTransactionsSuccessAction,
  getTransactionsErrorAction,
  getCountriesAction,
  getCountriesSuccessAction,
  getCountriesErrorAction,
} = transactionsList.actions;

export default transactionsList.reducer;
